import classnames from 'classnames/bind'
import React from 'react'

import Image from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import Link from '~/components/Link'
import RichText from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'
import { ListImageTextProps } from './types'

const cx = classnames.bind(css)

function ListImageText({ className, items }: ListImageTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const textStyle = useStyle({
    textPreset: 'title-heading-6',
    color: 'blue-bayoux',
  })

  return (
    <div className={cx(css.ListImageText, gridStyle, className)}>
      <div className={css.content}>
        {items?.map((item, index) => {
          return (
            <Link {...item?.link} className={css.item} key={index}>
              {item?.image && (
                <div className={css.itemImageWrapper}>
                  <ImageWithPlaceHolder
                    className={css.itemImage}
                    layout="fill"
                    objectFit="contain"
                    {...item.image}
                  />
                </div>
              )}
              {item?.text && (
                <RichText
                  className={cx(css.itemText, textStyle)}
                  render={item.text}
                />
              )}
            </Link>
          )
        })}
      </div>
    </div>
  )
}

ListImageText.defaultProps = {}

export default ListImageText
